import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";
import { AttoDTO } from "../dto/atto-DTO";

import { MapperSettore } from "./mapper-settore";
import { MapperUtente } from "./mapper-utente";
import { MapperDocumento } from "./mapper-documento";
import { MapperVisibilitaAtto } from "./mapper-visibilita-atto";
import { MapperMetadatiRepertorio } from "./mapper-metadati-repertorio";
import { MapperDatiContabili } from "./mapper-dati-contabili";
import { NotaLiquidazioneDTO } from "../dto/nota-liquidazioneDTO";
import { MapperAnagraficaBeneficiario } from "./mapper-anagrafica-beneficiario";
import { NotaLiquidazioneVO } from "../vo/nota-liquidazioneVO";
import { MapperDocumentoSpesa } from "./mapper-documento-spesa";
import { ThrowStmt } from "@angular/compiler";
import { MapperDecreto } from "./mapper-decreto";
import { MapperDatiPagamento } from "./mapper-dati-pagamento";
import { MapperNotaDaSostituire } from "./mapper-nota-da-sostituire";
import {NotaLiquidazioneHelper} from "@app/shared/helper/nota-liquidazione.helper";

@Injectable({ providedIn: "root" })
export class MapperNotaLiquidazione
  implements MapperInterface<NotaLiquidazioneDTO, NotaLiquidazioneVO> {
  constructor(
    private mapperAnagraficaBeneficiario: MapperAnagraficaBeneficiario,
    private utenteMapper: MapperUtente,
    private settoreMapper: MapperSettore,
    private documentoMapper: MapperDocumento,
    private documentoSpesaMapper: MapperDocumentoSpesa,
    private metadatiRepertorioMapper: MapperMetadatiRepertorio,
    private decretoMapper: MapperDecreto,
    private datiPagamentoMapper: MapperDatiPagamento,
    private notaDaSostituireMapper: MapperNotaDaSostituire
  ) { }

  convertVoToDto(notaLiquidazioneVO: NotaLiquidazioneVO): NotaLiquidazioneDTO {
    if (notaLiquidazioneVO != null) {
      const notaDTO = new NotaLiquidazioneDTO();

      notaDTO.id = notaLiquidazioneVO.id;
      notaDTO.decreto = this.decretoMapper.convertVoToDto(
        notaLiquidazioneVO.decreto
      );
      notaDTO.numeroFattura = notaLiquidazioneVO.numeroFattura;
      notaDTO.tipologiaNota = notaLiquidazioneVO.tipologiaNota;
      notaDTO.dataConclusione = notaLiquidazioneVO.dataConclusione;
      notaDTO.dataInserimento = notaLiquidazioneVO.dataInserimento;
      notaDTO.dataUltimaModifica = notaLiquidazioneVO.dataUltimaModifica;
      notaDTO.oggetto = notaLiquidazioneVO.oggetto;
      notaDTO.statoNota = notaLiquidazioneVO.stato;

      notaDTO.motivoStato = notaLiquidazioneVO.motivoStato;
      notaDTO.contenutoNota = notaLiquidazioneVO.contenutoNota;
      notaDTO.primario = this.documentoMapper.convertVoToDto(
        notaLiquidazioneVO.primario
      );
      notaDTO.allegati = notaLiquidazioneVO.allegati
        ? notaLiquidazioneVO.allegati.map(a => this.documentoMapper.convertVoToDto(a))
        : [];
      notaDTO.metadatiRepertorio = this.metadatiRepertorioMapper.convertVoToDto(
        notaLiquidazioneVO.metadatiRepertorio
      );
      notaDTO.settore = this.settoreMapper.convertVoToDto(
        notaLiquidazioneVO.settore
      );
      notaDTO.responsabile = this.utenteMapper.convertVoToDto(
        notaLiquidazioneVO.responsabile
      );
      notaDTO.estensore = this.utenteMapper.convertVoToDto(
        notaLiquidazioneVO.estensore
      );
      notaDTO.anagraficheBeneficiarie = this.mapperAnagraficaBeneficiario.convertListVoToDto(
        notaLiquidazioneVO.anagraficheBeneficiarie
      );
      notaDTO.datiPagamento = notaLiquidazioneVO.datiPagamento
        ? this.datiPagamentoMapper.convertListVoToDto(notaLiquidazioneVO.datiPagamento)
        : [];
      notaDTO.notaDaSostituire = this.notaDaSostituireMapper.convertVoToDto(
        notaLiquidazioneVO.notaDaSostituire
      );
      if (notaLiquidazioneVO.settoreFirmatario !== null && notaLiquidazioneVO.settoreFirmatario !== undefined) {
        notaDTO.settoreFirmatario = this.settoreMapper.convertVoToDto(
          notaLiquidazioneVO.settoreFirmatario
        );
      }
      notaDTO.presaInCaricoUtente = notaLiquidazioneVO.presaInCarico
        ? this.utenteMapper.convertVoToDto(notaLiquidazioneVO.presaInCarico)
        : null;
      notaDTO.cloneRitirata = notaLiquidazioneVO.cloneRitirata;

      return notaDTO || new NotaLiquidazioneDTO();
    } else {
      return null;
    }
  }

  convertDtoToVo(notaDTO: NotaLiquidazioneDTO): NotaLiquidazioneVO {
    if (notaDTO != null) {
      const notaLiquidazioneVO = new NotaLiquidazioneVO();

      notaLiquidazioneVO.id = notaDTO.id;
      notaLiquidazioneVO.decreto = this.decretoMapper.convertDtoToVo(
        notaDTO.decreto
      );
      notaLiquidazioneVO.numeroFattura = notaDTO.numeroFattura;
      notaLiquidazioneVO.tipologiaNota = notaDTO.tipologiaNota;
      notaLiquidazioneVO.dataConclusione = notaDTO.dataConclusione;
      notaLiquidazioneVO.dataInserimento = notaDTO.dataInserimento;
      notaLiquidazioneVO.dataUltimaModifica = notaDTO.dataUltimaModifica;
      notaLiquidazioneVO.oggetto = notaDTO.oggetto;
      notaLiquidazioneVO.stato = notaDTO.statoNota;
      notaLiquidazioneVO.contenutoNota = notaDTO.contenutoNota;
      notaLiquidazioneVO.motivoStato = notaDTO.motivoStato;
      notaLiquidazioneVO.primario = this.documentoMapper.convertDtoToVo(
        notaDTO.primario
      );
      notaLiquidazioneVO.allegati = notaDTO.allegati
        ? notaDTO.allegati.map(a => this.documentoMapper.convertDtoToVo(a))
        : [];
      notaLiquidazioneVO.metadatiRepertorio = this.metadatiRepertorioMapper.convertDtoToVo(
        notaDTO.metadatiRepertorio
      );
      notaLiquidazioneVO.settore = this.settoreMapper.convertDtoToVo(
        notaDTO.settore
      );
      notaLiquidazioneVO.responsabile = this.utenteMapper.convertDtoToVo(
        notaDTO.responsabile
      );
      notaLiquidazioneVO.estensore = this.utenteMapper.convertDtoToVo(
        notaDTO.estensore
      );
      notaLiquidazioneVO.anagraficheBeneficiarie = this.mapperAnagraficaBeneficiario.convertListDtoToVo(
        notaDTO.anagraficheBeneficiarie
      );
      if (notaDTO.anagraficheBeneficiarie && notaDTO.anagraficheBeneficiarie.length > 0) {
        notaLiquidazioneVO.anagraficheBeneficiarieString = notaDTO.anagraficheBeneficiarie
            .map<string>(value => value.denominazione).join(", ");
        const totali = NotaLiquidazioneHelper.getRiepilogoTotali(notaLiquidazioneVO);
        notaLiquidazioneVO.importoLordo = totali.importoLordo;
        notaLiquidazioneVO.importoNetto = totali.importoNetto;
        notaLiquidazioneVO.ritenute = totali.ritenute;
      }
      notaLiquidazioneVO.datiPagamento = notaDTO.datiPagamento
        ? this.datiPagamentoMapper.convertListDtoToVo(notaDTO.datiPagamento)
        : [];
      notaLiquidazioneVO.notaDaSostituire = this.notaDaSostituireMapper.convertDtoToVo(
        notaDTO.notaDaSostituire
      );
      if (notaDTO.settoreFirmatario !== null && notaDTO.settoreFirmatario !== undefined) {
        notaLiquidazioneVO.settoreFirmatario = this.settoreMapper.convertDtoToVo(
          notaDTO.settoreFirmatario
        );
      }
      notaLiquidazioneVO.presaInCarico = notaDTO.presaInCaricoUtente
        ? this.utenteMapper.convertDtoToVo(notaDTO.presaInCaricoUtente)
        : null;
      notaLiquidazioneVO.cloneRitirata = notaDTO.cloneRitirata;

      return notaLiquidazioneVO || new NotaLiquidazioneVO();
    } else {
      return null;
    }
  }

  convertListVoToDto(notaList: NotaLiquidazioneVO[]): NotaLiquidazioneDTO[] {
    const notaDTOList = new Array<NotaLiquidazioneDTO>();
    notaList.forEach((vo) => {
      notaDTOList.push(this.convertVoToDto(vo));
    });

    return notaDTOList || new Array<NotaLiquidazioneDTO>();
  }

  convertListDtoToVo(notaDTOList: NotaLiquidazioneDTO[]): NotaLiquidazioneVO[] {
    const notaLiquidazioneVOList = new Array<NotaLiquidazioneVO>();
    notaDTOList.forEach((dto) => {
      notaLiquidazioneVOList.push(this.convertDtoToVo(dto));
    });

    return notaLiquidazioneVOList || new Array<NotaLiquidazioneVO>();
  }
}
